import Services from '../../services';

import { message } from 'antd';

export default class Service extends Services {
  getDataNps = async (dataInicial, dataFinal, idFilial, idEmpresa) => {
    const tokenLogin = localStorage.getItem('token');
    try {
      let url = `${this.endPoint}Graficos/dadoGraficoNPS/${dataInicial}/${dataFinal}/${idFilial}`;
      if(idEmpresa > 0)
      {
        url += `?idEmpresa=${idEmpresa}`;
      }
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${tokenLogin}`,
          'Content-Type': 'application/json',
        },
      });

      // Forbid() do backend devolve 403 com corpo vazio - response.json() estoura
      // SyntaxError nesse caso e cairia no catch abaixo, que deslogava o usuario
      // (2026-08-11: usuario restrito por unidade recebe 403 aqui ao selecionar
      // "Ver todas as unidades", e era deslogado sem explicacao nenhuma).
      if (response.status === 403) {
        message.error('Você não tem permissão para ver os dados dessa seleção.');
        return null;
      }

      const json = await response.json();

      return json;
    } catch (err) {
      console.log('Error problem', err);
      this.doLogout()
    }
  };
}
